jQuery(document).ready(function ($) {
  if($('[data-slider="card"]').length){
    $('[data-slider="card"]').slick({
      infinite: true,
      arrows: true,
      dots: true,
      adaptiveHeight: true,
      prevArrow: $('.arrow-prev-custom'),
      nextArrow: $('.arrow-next-custom'),
      responsive: [
        {
          breakpoint: 768, // Mobile view
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1200, // Desktop view
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 9999, // Larger screens
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  }
});
